import { render, staticRenderFns } from "./Sender.vue?vue&type=template&id=6fea79b7&scoped=true&"
import script from "./Sender.vue?vue&type=script&lang=js&"
export * from "./Sender.vue?vue&type=script&lang=js&"
import style0 from "./Sender.vue?vue&type=style&index=0&id=6fea79b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../demo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea79b7",
  null
  
)

export default component.exports